export default __webpack_public_path__ + "static/media/Kollektiv35_StimmeX_Web-27.015833ee.jpg";